/**
 * Método de contacto que se le muestra a una psicóloga (mail + WhatsApp) para llegar al equipo.
 *
 * La resolución (fee_type=range o segmento nuevo en psychologist_psichat_inbox) la hace el
 * backend — ver `uses_admin_contact_channel` en GET /api/psychologist/profile, consumido por
 * `useContactChannel`. El frontend no tiene acceso directo a ninguna de las dos fuentes:
 * `fee_type` es una columna de MySQL que no viaja por ningún endpoint que consuma el FE, y la
 * tabla del segmento nuevo vive en una Supabase de otro proyecto (psima).
 *
 * Este archivo solo define los dos canales posibles (constantes) y `isNZContactOrigin`, que es
 * una regla DISTINTA (ranking, no fee_type) usada únicamente para permisos de derivación.
 */

export interface ContactChannel {
  email: string;
  /** Solo dígitos, con código de país — formato listo para wa.me / api.whatsapp.com. */
  whatsappNumber: string;
  /** Formato legible para mostrar en UI. */
  whatsappDisplay: string;
  /**
   * Canal de liquidaciones (cobros). Variable aparte de `email` porque su valor por defecto es
   * distinto: quien va por el canal estándar sigue escribiendo a liquidaciones@.
   */
  liquidacionesEmail: string;
}

export const STANDARD_CONTACT: ContactChannel = {
  email: 'administracion@psimammoliti.com',
  whatsappNumber: '5491124084954',
  whatsappDisplay: '+54 9 11 2408-4954',
  liquidacionesEmail: 'liquidaciones@psimammoliti.com',
};

export const NZ_CONTACT: ContactChannel = {
  email: 'administracion@psimammoliti.com',
  whatsappNumber: '15734554100',
  whatsappDisplay: '+1 573 455 4100',
  liquidacionesEmail: 'administracion@psimammoliti.com',
};

/**
 * Regla histórica de derivaciones — NO tocar el criterio: gobierna si se puede iniciar una
 * derivación (`disableReferForm` en PatientsContent.tsx). Es una regla de RANKING, distinta de
 * la que resuelve el canal de contacto en sí (esa es `fee_type`, resuelta server-side).
 */
export function isNZContactOrigin(
  rankingActual: string | null | undefined,
  rankingAnterior: string | null | undefined,
): boolean {
  return rankingActual === 'NZ' || (rankingActual === 'O' && rankingAnterior === 'NZ');
}

export function buildWhatsappLink(whatsappNumber: string, text?: string): string {
  const base = `https://api.whatsapp.com/send/?phone=${whatsappNumber}`;
  return text ? `${base}&text=${encodeURIComponent(text)}` : base;
}
